// extracted by mini-css-extract-plugin
export var divider = "PastEventsSection-module--divider--d7aa0";
export var label = "PastEventsSection-module--label--80ef0";
export var root = "PastEventsSection-module--root--3584e";